<template>
    <div>
        <!--begin::Row-->
        <div class="row mt-5">
            <div class="col-12">
                <!--begin::Charts Widget 6-->
                <div class="card card-custom card-stretch gutter-b">
                    <!--begin::Header-->
                    <div class="card-header">
                        <div class="card-title py-5">
                            <h3 class="card-label">
                <span class="d-block text-dark font-weight-bolder"
                >{{ $t("notifications.sending_messages") }}</span
                >
                            </h3>
                        </div>

                        <div></div>
                    </div>
                    <!--end::Header-->

                    <!--begin::Body-->
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6 ">
                                <h5 class="modal-title mb-lg-9">
                                    {{ $t("notifications.specify_recipients") }}
                                </h5>

                                <div class="d-flex flex-column">
                                    <div class="form-group">
                                        <label>{{ $t("notifications.which_game") }}</label>
                                        <div></div>
                                        <select class="form-control" @change="onChangeGame($event)"
                                                v-model="game_id">
                                            <option v-for="game in games" v-bind:value="game.value">
                                                {{ game.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label>{{ $t("notifications.who_should") }}</label>
                                        <div class="radio-inline">
                                            <label class="radio">
                                                <input
                                                        type="radio"
                                                        @change="onChangeRadio($event)"
                                                        id="all_gamers"
                                                        v-model="gamers_group_id"
                                                        value="1"
                                                />
                                                <span></span>{{ $t("notifications.all_patients") }}</label
                                            >
                                            <label class="radio" v-if="radioGamersGroupVisible">
                                                <input
                                                        type="radio"
                                                        @change="onChangeRadio($event)"
                                                        id="all_active_gamers"
                                                        v-model="gamers_group_id"
                                                        value="2"
                                                />
                                                <span></span>{{ $t("notifications.everyone_active_game") }}</label
                                            >
                                            <label class="radio" v-if="radioGamersGroupVisible">
                                                <input
                                                        type="radio"
                                                        @change="onChangeRadio($event)"
                                                        id="all_disabled_gamers"
                                                        v-model="gamers_group_id"
                                                        value="3"
                                                />
                                                <span></span>{{ $t("notifications.anyone_inactive_game") }}</label
                                            >
                                            <label class="radio">
                                                <input
                                                        type="radio"
                                                        @change="onChangeRadio($event)"
                                                        id="selected_gamers"
                                                        v-model="gamers_group_id"
                                                        value="4"
                                                />
                                                <span></span>{{ $t("notifications.specify_from_list") }}</label
                                            >
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <select
                                                :disabled="selectGamersDisable"
                                                multiple
                                                class="form-control h-200px"
                                                v-model="selected_gamers_fcm_tokens"
                                        >
                                            <option
                                                    v-for="gamer in gamers_fcm_tokens"
                                                    v-bind:value="gamer.fcm_token"
                                            >
                                                {{gamer.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 ">
                                <h5 class="modal-title mb-4">{{ $t("notifications.use_post_template") }}</h5>

                                <ul class="nav nav-tabs">
                                    <li class="nav-item" v-if="messages[0]">
                                        <a
                                                v-if="message_id == 0"
                                                @click="onChangeMessage(0)"
                                                class="nav-link active"
                                                data-toggle="tab"
                                                href="#"
                                        >
                                            <span class="nav-text">{{ $t("notifications.new") }}</span>
                                        </a>
                                        <a
                                                v-else
                                                @click="onChangeMessage(0)"
                                                class="nav-link"
                                                data-toggle="tab"
                                                href="#"
                                        >
                                            <span class="nav-text">{{ $t("notifications.new") }}</span>
                                        </a>
                                    </li>
                                    <li class="nav-item" v-if="messages[1]">
                                        <a
                                                v-if="message_id == 1"
                                                @click="onChangeMessage(1)"
                                                class="nav-link active"
                                                data-toggle="tab"
                                                href="#"
                                        >
                                            <span class="nav-text">{{ $t("notifications.template_1") }}</span>
                                        </a>
                                        <a
                                                v-else
                                                @click="onChangeMessage(1)"
                                                class="nav-link"
                                                data-toggle="tab"
                                                href="#"
                                        >
                                            <span class="nav-text">{{ $t("notifications.template_1") }}</span>
                                        </a>
                                    </li>
                                    <li class="nav-item" v-if="messages[2]">
                                        <a
                                                v-if="message_id == 2"
                                                @click="onChangeMessage(2)"
                                                class="nav-link active"
                                                data-toggle="tab"
                                                href="#"
                                        >
                                            <span class="nav-text">{{ $t("notifications.template_2") }}</span>
                                        </a>
                                        <a
                                                v-else
                                                @click="onChangeMessage(2)"
                                                class="nav-link"
                                                data-toggle="tab"
                                                href="#"
                                        >
                                            <span class="nav-text">{{ $t("notifications.template_2") }}</span>
                                        </a>
                                    </li>
                                    <li class="nav-item" v-if="messages[3]">
                                        <a
                                                v-if="message_id == 3"
                                                @click="onChangeMessage(3)"
                                                class="nav-link active"
                                                data-toggle="tab"
                                                href="#"
                                        >
                                            <span class="nav-text">{{ $t("notifications.template_3") }}</span>
                                        </a>
                                        <a
                                                v-else
                                                @click="onChangeMessage(3)"
                                                class="nav-link"
                                                data-toggle="tab"
                                                href="#"
                                        >
                                            <span class="nav-text">{{ $t("notifications.template_3") }}</span>
                                        </a>
                                    </li>
                                </ul>
                                <div class="tab-content mt-5">
                                    <form class="form" @submit.prevent="handleSubmit">
                                        <div class="form-group">
                                            <label for="fcm_title">{{ $t("notifications.name") }}</label>
                                            <input
                                                    id="fcm_title"
                                                    type="text"
                                                    class="form-control"
                                                    maxlength="64"
                                                    v-model.trim="fcm_title"
                                                    :class="{
                          invalid:
                            ($v.fcm_title.$dirty && !$v.fcm_title.required) ||
                            ($v.fcm_title.$dirty && !$v.fcm_title.maxLength)
                        }"
                                            />
                                            <span
                                                    v-if="$v.fcm_title.$dirty && !$v.fcm_title.required"
                                                    class="helper-text invalid"
                                            >{{ $t("notifications.enter_name") }}</span
                                            >
                                            <small
                                                    class="helper-text invalid"
                                                    v-else-if="
                          $v.fcm_title.$dirty && !$v.fcm_title.maxLength
                        "
                                            >{{ $t("notifications.max_length") }}{{ $v.fcm_title.$params.maxLength.max
                                                }}
                                            </small>
                                        </div>

                                        <div class="form-group">
                                            <label for="fcm_text">{{ $t("notifications.message") }}</label>
                                            <textarea
                                                    id="fcm_text"
                                                    type="text"
                                                    class="form-control"
                                                    rows="6"
                                                    maxlength="2000"
                                                    v-model.trim="fcm_text"
                                                    :class="{
                          invalid:
                            ($v.fcm_text.$dirty && !$v.fcm_text.required) ||
                            ($v.fcm_text.$dirty && !$v.fcm_text.maxLength)
                        }"
                                            ></textarea>
                                            <span
                                                    v-if="$v.fcm_text.$dirty && !$v.fcm_text.required"
                                                    class="helper-text invalid"
                                            >{{ $t("notifications.enter_text") }}</span
                                            >
                                            <small
                                                    class="helper-text invalid"
                                                    v-else-if="$v.fcm_text.$dirty && !$v.fcm_text.maxLength"
                                            >{{ $t("notifications.max_length") }} {{ $v.fcm_text.$params.maxLength.max
                                                }}
                                            </small>
                                        </div>

                                        <div class="d-flex flex-column flex-sm-row">
                                            <a
                                                    v-on:click="showSendAlert"
                                                    href="#"
                                                    class="btn bnt-sm btn-primary font-weight-bold
                        text-center"
                                            >
                                                {{ $t("notifications.send") }}
                                            </a>
                                            <button v-if="show_save_btn" type="submit"
                                                    class="btn bnt-sm btn-light-primary font-bold text-center ml-lg-auto mt-3 mt-sm-0">
                                                {{ $t("notifications.save_template") }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--end::Body-->
                </div>
                <!--end::Charts Widget 6-->
            </div>
        </div>
        <!--end::Row-->
    </div>
</template>
<script>
    import {required, maxLength} from "vuelidate/lib/validators";
    import firebase from 'firebase/app'
    import {
        ADD_BODY_CLASSNAME,
        REMOVE_BODY_CLASSNAME
    } from "@/core/services/store/htmlclass.module.js";
    import {
        mapGetters,
        mapActions
        //mapState
    } from "vuex";

    export default {
        data: () => ({
            show_save_btn: false,
            gamers: [],
            gamers_list: [],
            fcm_tokens: [],
            gamers_fcm_tokens: [],
            selected_gamers_fcm_tokens: [],
            fcm_title: "",
            fcm_text: "",
            message_id: 0,
            messages: {},
            message: null,
            gamers_group_id: 1,
            game_id: 0,
            selectGamersDisable: true,
            radioGamersGroupVisible: false,
            games: [
                {text: 'Last active', value: 0},
                {text: 'Okolo Ball', value: 1},
                {text: 'Okolo Spider', value: 2},
                {text: 'Okolo Crosses', value: 3},
                {text: 'Okolo Puzzles', value: 4},
            ]
        }),
        validations: {
            fcm_title: {required, maxLength: maxLength(64)},
            fcm_text: {required, maxLength: maxLength(2000)}
        },
        computed: {
            ...mapGetters([
                "layoutConfig",
                "getUserId",
                "getPatients",
                "getDoctorMessages"
            ])
        },
        async mounted() {
            var d = document.getElementById("kt_aside_tab_5");
            d.className += " btn-clean active";
            this.games[0].text = this.$t("notifications.last_active");

            await this.fetchDoctorById(this.getUserId);
            await this.fetchPatientsByDoctorId(this.getUserId);
            this.messages = this.getDoctorMessages;
            this.gamers = this.getPatients;
            this.updateCurrentMessage();
            this.updateGamersList();
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
        },
        methods: {
            ...mapActions([
                "fetchDoctorById",
                "fetchPatientsByDoctorId",
                "updateDoctorMessagesById"
            ]),
            async handleSubmit() {
                if (this.$v.$invalid) {
                    this.$v.$touch();
                    this.$error("Check the fields");
                    return;
                }
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                try {
                    let currentObj = this;

                    const gamerData = {
                        id: this.getUserId,
                        message_id: this.message_id + 1,
                        text: this.fcm_text,
                        title: this.fcm_title
                    };
                    this.loading = true;
                    await this.updateDoctorMessagesById(gamerData)
                        .then(() => {
                            currentObj.fetchAndUpdateMessages();
                            currentObj.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                            currentObj.$v.$reset();
                        })
                        .catch(() => {
                            currentObj.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                        });

                    this.$v.$reset();
                } catch (e) {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                }
            },
            async sendMessage() {
                let tokens = [];
                let gamersListForSaveMessage = [];

                if (
                    this.gamers_group_id == 1 ||
                    this.gamers_group_id == 2 ||
                    this.gamers_group_id == 3
                ) {
                    tokens = this.fcm_tokens;
                } else {
                    tokens = this.selected_gamers_fcm_tokens;
                }
                this.gamers_fcm_tokens.forEach((item) => {

                    if(tokens.indexOf( item.fcm_token ) != -1 ){
                        gamersListForSaveMessage.push(item)
                    }
                })

                console.log(gamersListForSaveMessage)

                if (tokens.length == 0) {
                    return "tokens_empty";
                }

                let addMessage = await firebase
                    .functions()
                    .httpsCallable("sendNotificationToUsers");
                addMessage({
                    title: this.fcm_title,
                    body: this.fcm_text,
                    tokens: tokens,
                    recipients: gamersListForSaveMessage,
                })
                    .then(function () {
                        return "success";
                    })
                    .catch(() => {
                        return "error";
                    });
            },
            onChangeMessage(messageId) {
                this.show_save_btn = messageId !== 0;
                this.message_id = messageId;
                this.updateCurrentMessage();
            },
            onChangeGame(event) {
                this.game_id = event.target.value;

                if (this.game_id == 0) {
                    this.radioGamersGroupVisible = false;
                } else {
                    this.radioGamersGroupVisible = true;
                }

                this.updateGamersList();
            },
            async fetchAndUpdateMessages() {
                await this.fetchDoctorById(this.getUserId);
                this.messages = this.getDoctorMessages;
            },
            updateGamersList() {
                this.gamers_list = this.gamers.map(gamer => {
                    return {
                        ...gamer,
                    };
                });

                this.gamers_list.sort(function (a, b) {
                    return b.create_date - a.create_date;
                });

                this.gamers_list = this.gamers_list.map(gamer => {
                    return {
                        ...gamer,
                        name: gamer.last_name + " " + gamer.first_name
                    };
                });
                this.gamers_fcm_tokens = [];
                this.fcm_tokens = [];

                this.gamers_list.forEach((gamer) => {
                    if (this.game_id > 0) {
                        if (gamer.game_info[this.game_id].fcm_token && gamer.game_info[this.game_id].fcm_token != "...") {
                            switch (this.gamers_group_id) {
                                case 1:
                                    this.gamers_fcm_tokens.push({
                                        name: gamer.name,
                                        fcm_token: gamer.game_info[this.game_id].fcm_token,
                                        gamer_key: gamer.key,
                                        game_id: this.game_id
                                    })
                                    this.fcm_tokens.push(gamer.game_info[this.game_id].fcm_token)
                                    break;
                                case 2:
                                    if (gamer.game_info[this.game_id].active) {
                                        this.gamers_fcm_tokens.push({
                                            name: gamer.name,
                                            fcm_token: gamer.game_info[this.game_id].fcm_token,
                                            gamer_key: gamer.key,
                                            game_id: this.game_id
                                        })
                                        this.fcm_tokens.push(gamer.game_info[this.game_id].fcm_token)
                                    }
                                    break;
                                case 3:
                                    if (!gamer.game_info[this.game_id].active) {
                                        this.gamers_fcm_tokens.push({
                                            name: gamer.name,
                                            fcm_token: gamer.game_info[this.game_id].fcm_token,
                                            gamer_key: gamer.key,
                                            game_id: this.game_id
                                        })
                                        this.fcm_tokens.push(gamer.game_info[this.game_id].fcm_token)
                                    }
                                    break;
                                case 4:
                                    this.gamers_fcm_tokens.push({
                                        name: gamer.name,
                                        fcm_token: gamer.game_info[this.game_id].fcm_token,
                                        gamer_key: gamer.key,
                                        game_id: this.game_id
                                    })
                                    this.fcm_tokens.push(gamer.game_info[this.game_id].fcm_token)
                                    break;
                            }
                        }
                    }
                    else {

                        if (gamer.fcm_token && gamer.fcm_token != "...") {
                            let _gamer_id = 0;
                            for (let i  = 1; i <= 4; i++) {
                                if (gamer.fcm_token == gamer.game_info[i].fcm_token) {
                                    _gamer_id = i;
                                }
                            }

                            this.gamers_fcm_tokens.push({
                                name: gamer.name,
                                fcm_token: gamer.fcm_token,
                                gamer_key: gamer.id,
                                game_id: _gamer_id
                            })

                            this.fcm_tokens.push(gamer.fcm_token)
                        }
                    }

                });
            },
            updateCurrentMessage() {
                this.message = this.messages[this.message_id];
                this.fcm_text = this.message.text;
                this.fcm_title = this.message.title;
            },
            async showSendAlert() {
                this.$swal({
                    title: this.$t("notifications.want_send"),
                    text: this.fcm_text,
                    showCancelButton: true,
                    confirmButtonColor: "#2f61f8",
                    cancelButtonColor: "#ff5252",
                    confirmButtonText: this.$t("notifications.of_course"),
                    cancelButtonText: this.$t("notifications.cancel"),
                }).then(async result => {
                    if (result.value) {
                        await this.sendMessage().then(result => {
                            if (result == "success") {
                                this.$swal({
                                    title: this.$t("notifications.sent"),
                                    text:
                                        this.$t("notifications.sent_message"),
                                    showCancelButton: false,
                                    confirmButtonColor: "#2f61f8",
                                    confirmButtonText: this.$t("notifications.of_course"),
                                });
                            } else if (result == "tokens_empty") {
                                this.$swal({
                                    title: this.$t("notifications.not_sent"),
                                    text: this.$t("notifications.list_empty"),
                                    showCancelButton: false,
                                    confirmButtonColor: "#2f61f8",
                                    confirmButtonText: this.$t("notifications.of_course"),
                                });
                            } else if (result == "error") {
                                this.$swal({
                                    title: this.$t("notifications.error"),
                                    text: this.$t("notifications.contact_admin"),
                                    showCancelButton: false,
                                    confirmButtonColor: "#2f61f8",
                                    confirmButtonText: this.$t("notifications.of_course"),
                                });
                            }
                        });
                    }
                });
            },
            async onChangeRadio(event) {
                switch (event.target.value) {
                    case "1":
                        this.selectGamersDisable = true;
                        this.gamers_group_id = 1;
                        this.updateGamersList();
                        break;
                    case "2":
                        this.selectGamersDisable = true;
                        this.gamers_group_id = 2;
                        this.updateGamersList();
                        break;
                    case "3":
                        this.selectGamersDisable = true;
                        this.gamers_group_id = 3;
                        this.updateGamersList();
                        break;
                    case "4":
                        this.selectGamersDisable = false;
                        this.gamers_group_id = 4;
                        this.updateGamersList();
                        break;
                    default:
                        break;
                }
            }
        }
    };
</script>
